import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';

class MeishiMap extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        handleChange: PropTypes.func,
    };

    handleClick = area => {
        this.props.handleChange(area);
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.meishiMap}>
                <div className={styles.navBar} />
                <div className={styles.maps}>
                    {content.map((item, index) => (
                        <div
                            key={index}
                            className={styles.mapItem}
                            onClick={() => this.handleClick(item.area)}
                            style={{ marginRight: index % `${3}` === 2 ? 0 : 18 }}>
                            <div className={styles.block}>
                                {!!item.image && <img src={formatImage(item.image, 310, 170)} alt="" />}
                            </div>
                            <div className={styles.text}>
                                <p className={styles.titleText}>{item.title}</p>
                                <p className={styles.titleDate}>{item.date}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}

const MeishiMapChip = props => {
    return (
        <Chip id="170203" type="struct" title="美食盛典-美食区域地图" groupName="正文-首页" content={props.content}>
            <MeishiMap handleChange={props.handleChange} />
        </Chip>
    );
};

MeishiMapChip.propTypes = {
    content: PropTypes.array,
    handleChange: PropTypes.func,
};

export default errorBoundary(MeishiMapChip);
